export default {
  VIEWED_TUTORIAL_KEY: '@twism:viewed-customer-inactivity-tutorial',
  DEFAULT_SLUG_DAYS: '30Days',
  DEFAULT_DAYS: 30
};
